import { render, staticRenderFns } from "./App.vue?vue&type=template&id=f6485320"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=f6485320&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_eb30a0289a409b0a489ae932e3a15a73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports